// Date display. Never print an ISO-8601 string into the UI.

const pad = (n) => String(n).padStart(2, "0")

export const parseDate = (value) => {
  if (!value) return null
  const d = value instanceof Date ? value : new Date(value)
  return Number.isNaN(d.getTime()) ? null : d
}

// 07/09/2026
export const formatDate = (value) => {
  const d = parseDate(value)
  if (!d) return "—"
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`
}

// 07/09/2026 · 11:53
export const formatDateTime = (value) => {
  const d = parseDate(value)
  if (!d) return "—"
  return `${formatDate(d)} · ${pad(d.getHours())}:${pad(d.getMinutes())}`
}

export const formatDateTimeFull = (value) => {
  const d = parseDate(value)
  if (!d) return "—"
  return d.toLocaleString("en-GB", {
    weekday: "short",
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  })
}

export const formatRelative = (value, now = new Date()) => {
  const d = parseDate(value)
  if (!d) return "—"
  const diffMs = now.getTime() - d.getTime()
  const future = diffMs < 0
  const abs = Math.abs(diffMs)
  const min = Math.round(abs / 60000)
  const hour = Math.round(abs / 3600000)
  const day = Math.round(abs / 86400000)
  if (min < 1) return "Just now"
  if (min < 60) return future ? `In ${min} min` : `${min} min ago`
  if (hour < 24) return future ? `In ${hour} hour${hour === 1 ? "" : "s"}` : `${hour} hour${hour === 1 ? "" : "s"} ago`
  if (day < 7) return future ? `In ${day} day${day === 1 ? "" : "s"}` : `${day} day${day === 1 ? "" : "s"} ago`
  return formatDate(d)
}

export const isCurrentMonth = (value, now = new Date()) => {
  const d = parseDate(value)
  if (!d) return false
  return d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth()
}
